module.exports = __webpack_public_path__ + "img/approve.0cc157a7.png";